import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    quicklinks: null,
};

export const quicklinkSlice = createSlice({
    name: "quicklinks",
    initialState,
    reducers: {
        updateQuickLinks: (state, action) => {
            state.quicklinks = action.payload;
        },
        clearQuickLinks: (state) => {
            state.quicklinks = null;
        },        
    },
});

export const { updateQuickLinks, clearQuickLinks } = quicklinkSlice.actions;

export default quicklinkSlice.reducer;
